import { Api } from '@/api/api';

export class EmailAttachmentApi extends Api {
    public async getEmailAttachmentsAsync(): Promise<Array<string>> {
        return this.getAsync<Array<string>>(`v1/emailattachment`);
    }

    public async emailAttachmentAsync(data: File): Promise<string> {
        return this.postFileAsync<string>(`v1/emailattachment`, data);
    }

    public constructor() {
        super();
    }
}
